const vario160Data = {
  slug: "vario-160",
  name: "Honda Vario 160",

  hero: {
    shortDescription:
      "Skutik premium 160cc dengan desain sporty, mesin eSP+ bertenaga, dan fitur canggih untuk mobilitas modern",

    variants: [
      {
        key: "cbs-active-matte-black",
        label: "CBS",
        fullName: "New Honda Vario 160 CBS Active Matte Black",
        startPrice: 28342000,
      },
      {
        key: "cbs-grande-matte-white",
        label: "CBS",
        fullName: "New Honda Vario 160 CBS Grande Matte White",
        startPrice: 28592000,
      },
      {
        key: "abs-grande-matte-blue",
        label: "ABS",
        fullName: "New Honda Vario 160 ABS Grande Matte Blue",
        startPrice: 32091000,
      },
    ],

    slides: [
      {
        variantKey: "cbs-active-matte-black",
        image: "/assets/motor/produk/vario160/New-Honda-Vario-160-CBS-Active-Matte-Black-300x300_c.webp",
        specs: {
          engine: "156,9 cc",
          transmission: "Otomatis V-Matic",
          feature: "PGM-FI eSP+",
        },
      },
      {
        variantKey: "cbs-grande-matte-white",
        image: "/assets/motor/produk/vario160/New-Honda-Vario-160-ABS-Grande-Matte-White-300x300_c.webp",
        specs: {
          engine: "156,9 cc",
          transmission: "Otomatis V-Matic",
          feature: "PGM-FI eSP+",
        },
      },
      {
        variantKey: "abs-grande-matte-blue",
        image: "/assets/motor/produk/vario160/Vario-160-ABS-Grande-Matte-Blue-300x300_c.webp",
        specs: {
          engine: "156,9 cc",
          transmission: "Otomatis V-Matic",
          feature: "PGM-FI eSP+ + ABS",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Vario 160 hadir dengan tampilan sporty dan mesin generasi terbaru yang memberikan performa lebih responsif.",
      },
      {
        type: "paragraph",
        text:
          "Mengusung mesin 160cc eSP+ 4 katup berpendingin cairan, Vario 160 menawarkan akselerasi kuat dan efisiensi bahan bakar optimal.",
      },
      {
        type: "heading",
        text: "Performa Mesin eSP+ 160cc",
      },
      {
        type: "paragraph",
        text:
          "Teknologi eSP+ meningkatkan tenaga dan efisiensi sekaligus menjaga kenyamanan berkendara.",
      },
      {
        type: "heading",
        text: "Fitur Premium & Keamanan",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi Smart Key System, panel meter digital, serta ABS untuk varian tertentu.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, 4 Katup, SOHC, eSP+"],
      ["Kapasitas Mesin", "156,9 cc"],
      ["Sistem Pendingin", "Pendingin Cairan"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "11,3 kW / 8.500 rpm"],
      ["Torsi Maksimum", "13,8 Nm / 7.000 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun dengan Suspensi Tunggal"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
      ["Sistem Pengereman", "CBS / ABS (tipe ABS)"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.929 x 679 x 1.088 mm"],
      ["Jarak Sumbu Roda", "1.277 mm"],
      ["Tinggi Jok", "778 mm"],
      ["Berat", "115 kg (CBS) / 117 kg (ABS)"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "5,5 Liter"],
      ["Kapasitas Bagasi", "18 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Full Digital"],
      ["Lampu Depan", "LED"],
      ["Tipe Aki", "MF Battery"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Vario 160",
    items: [
      {
        title: "Mesin 160cc eSP+ 4 Katup",
        desc:
          "Performa bertenaga dengan efisiensi bahan bakar tinggi.",
      },
      {
        title: "Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system.",
      },
      {
        title: "Anti-lock Braking System (ABS)",
        desc:
          "Menjaga kestabilan pengereman pada kondisi darurat (varian ABS).",
      },
      {
        title: "Full Digital Panel Meter",
        desc:
          "Tampilan modern dengan informasi berkendara lengkap.",
      },
      {
        title: "Full LED Lighting",
        desc:
          "Pencahayaan terang dan tahan lama.",
      },
      {
        title: "Bagasi 18 Liter",
        desc:
          "Muat helm dan barang harian dengan praktis.",
      },
    ],
  },
};

export default vario160Data;
